import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from 'components/pure/utils/Dialog';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import UpcomingReviewsStore from 'stores/coaching/UpcomingReviewsStore';
import AuthStore from 'stores/AuthStore';
import CoachingAgendaCard from 'components/dashboard/CoachingAgendaCard';
import './ModalExtrasContainer.styl';
import {CallToAction} from 'components/pure/tooltips/CallToAction';
import Loading from 'components/pure/utils/Loading';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';

@connectToStores
export default class ModalExtrasContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showReminderModal: false,
      reminderAlreadySent: false,
      error: false,
    };
  }

  static getStores() {
    return [AuthStore, UpcomingReviewsStore, CoachingPlanStore];
  }

  static getPropsFromStores(props) {
    const upcomingReviews = UpcomingReviewsStore.getState().upcomingReviewsMap;
    const sessionUser = AuthStore.getState().user;
    const {planMap} = CoachingPlanStore.getState();

    return {
      sessionUser,
      upcomingReviews: upcomingReviews.get(sessionUser.id),
      plans: planMap.toList(),
    };
  }

  componentDidMount() {
    const {reminderReviewId, sessionUser} = this.props;

    if (reminderReviewId) {
      this.setState({showReminderModal: true});

      UpcomingReviewsActions.sendReminder(sessionUser.id, reminderReviewId).then(
        () => null,
        e => {
          if (e.response && e.response.status === 409) {
            this.setState({reminderAlreadySent: true});
          } else {
            this.setState({error: true});
          }
        }
      );
    }
  }

  render() {
    const {showReminderModal, reminderAlreadySent, error} = this.state;
    const {upcomingReviews, reminderReviewId, plans} = this.props;

    const upcomingReview = upcomingReviews && upcomingReviews.get(reminderReviewId);

    const showSuccess = upcomingReview && !reminderAlreadySent;
    const showLoading = !showSuccess && !reminderAlreadySent && !error;

    return (
      <div className={'body'}>
        <Dialog
          contentClassName="reminder-sent-dialog"
          open={showReminderModal}
          title="Reminder sent!"
          onRequestClose={() => this.setState({showReminderModal: false})}
          actions={[
            <Button
              variant="contained"
              color="primary"
              className="ev-button"
              onClick={() => this.setState({showReminderModal: false})}>
              Done
            </Button>,
          ]}>
          {showSuccess && (
            <div>
              <CoachingAgendaCard
                rep={upcomingReview.rep}
                pendingType="REP"
                review={upcomingReview}
                suppressHover
                plans={plans}
              />
              <CallToAction
                text={`We sent ${upcomingReview.rep.firstName} an email reminder to follow up.`}
              />
            </div>
          )}
          {reminderAlreadySent && (
            <CallToAction
              text={`We sent that email reminder recently. Have the rep check their email.`}
            />
          )}
          {error && (
            <CallToAction
              text={`We encountered an error sending the reminder email.  Please reach out to support for assistance.`}
            />
          )}
          {showLoading && <Loading />}
        </Dialog>
      </div>
    );
  }
}
